import { disablePageScroll, enablePageScroll } from 'scroll-lock';

function popupOldPopup() {
  let button = $('.courses-page__link-nolink');
  let close = $('.popup-old__button, .popup-old__close');
  let popup = $('.popup-old');
  button.on('click', function() {
    if ($(this).hasClass('active')) {
      $(this).next().removeClass('active');
      enablePageScroll();
      $(this).removeClass('active');
    } else {
      $(this).next().addClass('active');
      disablePageScroll();
      $(this).addClass('active');
    }
  });
  close.on('click', function() {
    popup.removeClass('active');
    enablePageScroll();
    button.removeClass('active');
  });
  $(window).on('resize', function() {
    if ($(window).width() >= 1110 && button.hasClass('active')) {
      button.removeClass('active');
      popup.removeClass('active');
      enablePageScroll();
    }
  });
}
popupOldPopup();